module.exports = __webpack_public_path__ + "img/tablero-sin-documentacion.af2bf716.svg";